enum MasEnvironment {
  DEV = 'DEV',
  ACC = 'ACC',
  PREPROD = 'PREPROD',
  BETA = 'BETA',
  PROD = 'PROD',
}

export default MasEnvironment;
